<template>
    <div>
        <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">盘点单信息</div>
        <table class="simple-tbl" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size:12px; word-break:break-strict;">
            <tbody class="body">
            <tr class="row">
                <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 8px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                    <span>基本信息</span>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 8px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>盘点单名称</span></div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{voucher.title}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 8px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>盘点单号</span></div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span>{{voucher.no}}</span>
                            <span style="color: #2d8cf0;font-size: 12px;" v-if="voucher.spotFlag">抽盘</span>
                            <span style="color: #2d8cf0;font-size: 12px;" v-if="voucher.quickFlag">快盘</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 8px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>盘点方式</span>
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span v-if="voucher.openMode">明盘</span>
                            <span v-else>暗盘</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">盘点所属部门
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span v-if="voucher.retailerComId == voucher.retailerBizUnitId">{{voucher.retailerComName}}</span>
                            <span v-else>{{voucher.retailerBizUnitName}} - {{voucher.retailerComName}}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 8px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">盘点仓库</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{voucher.warehouseName}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 8px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;"><span>自盘负责人</span>
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <sapn>{{voucher.principalName}}</sapn>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 8px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>自盘负责人是否确认</span>
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span v-if="voucher.confirmed">已确认</span>
                            <span v-else>未确认</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 8px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>抽盘负责人</span>
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;"><span>{{voucher.spotPrincipalName}}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 8px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>抽盘负责人是否确认</span>
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span v-if="voucher.spotConfirmed">已确认</span>
                            <span v-else>未确认</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 8px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>状态</span></div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span v-if="voucher.state == 0">未开始</span>
                            <span v-if="voucher.state == 1">已开始</span>
                            <span v-if="voucher.state == 2">已结束</span>
                            <span v-if="voucher.state == -1">已取消</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 8px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>开始时间</span></div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;"><span>{{voucher.startTime}}</span></div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 8px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">结束时间</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span>{{voucher.endTime}}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 8px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">取消时间</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;"><span>{{voucher.cancelTime}}</span></div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 8px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">创建时间</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;"><span>{{voucher.createTime}}</span></div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 8px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">创建人</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;"><span>{{voucher.creatorName}}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 8px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">创建机构</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;"><span>{{voucher.creatorComName}}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 8px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">资产类型</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span>{{voucher.assetType == 2 ? '耗材' : '非耗材'}}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 8px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">备注</div>
                        <span>{{voucher.memo}}</span>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
        <table class="simple-tbl" v-if="voucher.assetType != 2" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size:12px; word-break:break-strict;">
            <tbody class="body">
            <tr class="row">
                <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                    <span>盘点单品式统计信息</span>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>盘点总数量</span></div>
                        <div class="value" style="padding-left: 82px;white-space: normal; word-break: break-all;"><span>{{voucher.totalCount}}</span></div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>已盘数量</span></div>
                        <div class="value" style="padding-left: 82px;white-space: normal; word-break: break-all;">
                            <span>{{voucher.checkedCount}}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>未盘数量</span>
                        </div>
                        <div class="value" style="padding-left: 82px;white-space: normal; word-break: break-all;">
                            <span>{{voucher.totalCount - voucher.checkedCount}}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;"><span>外部盘点数量</span>
                        </div>
                        <div class="value" style="padding-left: 82px;white-space: normal; word-break: break-all;"><span>{{voucher.singleOuterCount}}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>追加盘点数量</span>
                        </div>
                        <div class="value" style="padding-left: 82px;white-space: normal; word-break: break-all;">
                            <span>{{voucher.singlePostAddedCount}}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;"></td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;"></td>
            </tr>
            </tbody>
        </table>
        <table class="simple-tbl" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size:12px; word-break:break-strict;">
            <tbody class="body">
            <tr class="row">
                <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                    <span>{{voucher.assetType != 2? '盘点批量式统计信息':'盘点耗材统计信息'}} </span>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>{{voucher.assetType != 2 ? '盘点批次数量' : '盘点耗材数量'}}</span></div>
                        <div class="value" style="padding-left: 82px;white-space: normal; word-break: break-all;"><span>{{voucher.durableTotalCount}}</span>
                        </div>
                    </div>

                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>{{voucher.assetType != 2 ? '已盘批次数量' : '已盘耗材数量'}}</span></div>
                        <div class="value" style="padding-left: 82px;white-space: normal; word-break: break-all;">
                            <span>{{voucher.durableCheckedCount}}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>{{voucher.assetType != 2 ? '未盘批次数量' : '未盘耗材数量'}}</span>
                        </div>
                        <div class="value" style="padding-left: 82px;white-space: normal; word-break: break-all;">
                            <span>{{voucher.durableTotalCount - voucher.durableCheckedCount}}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <!--<td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">-->
                    <!--<div class="info-item " style="overflow:hidden;">-->
                        <!--<div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">-->
                            <!--<span>正常数量</span>-->
                        <!--</div>-->
                        <!--<div class="value" style="padding-left: 82px;white-space: normal; word-break: break-all;">-->
                            <!--<span>{{voucher.durableCheckedNormalCount}}</span>-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</td>-->
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>盘盈数量</span>
                        </div>
                        <div class="value" style="padding-left: 82px;white-space: normal; word-break: break-all;">
                            <span>{{voucher.durableCheckedMoreCount}}</span></div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>盘亏数量</span>
                        </div>
                        <div class="value" style="padding-left: 82px;white-space: normal; word-break: break-all;">
                            <span>{{voucher.durableCheckedLackCount}}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span> 外部盘点数量</span>
                        </div>
                        <div class="value" style="padding-left: 82px;white-space: normal; word-break: break-all;">
                            <span>{{voucher.durableOuterCount}}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>追加盘点数量</span>
                        </div>
                        <div class="value" style="padding-left: 82px;white-space: normal; word-break: break-all;">
                            <span>{{voucher.durablePostAddedCount}}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;"></td>
            </tr>
            <tr class="row">
                <td style="font-weight: 600;font-size: 15px;border: 1px solid #1a1a1a;color: #1a1a1a;vertical-align: middle;padding: 10px 4px;font-size: 15px;" colspan="3">
                    <span>结果说明</span>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px; height:120px;" colspan="3">
                    <span>{{voucher.postAddedMemo}}</span>
                </td>
            </tr>
            <tr class="row">
                <td colspan="3" style="text-align: right; border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">(资产负责人审核)可上传代替审核</td>
            </tr>
            </tbody>
        </table>
        <template>
            <template v-if="deviceItemList != null && deviceItemList.length > 0">
                <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">单品式管理</div>
                <div style="border: 1px solid rgb(26, 26, 26); margin-top: 10px;" v-for="deviceItem in deviceItemList">
                    <div style="overflow: hidden; padding: 5px 2px 5px;">
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>系统编号</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span>{{deviceItem.tmpNo}}</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>资产描述全称</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span>{{deviceItem.title}}</span>
                                <span style="color: #2d8cf0;font-size: 12px;" v-if="deviceItem.postAdded">追加</span>
                                <span style="color: #2d8cf0;font-size: 12px;" v-if="deviceItem.outerFlag">助手</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>名称</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span>{{deviceItem.name || ''}}</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>型号</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span>{{deviceItem.model || ''}}</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>规格</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span>{{deviceItem.fixedSpec || ''}}</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>分类</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span>{{deviceItem.catName}}</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>分类分组</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span> {{getDevcGroupNameByCatId(deviceItem.catId)}}</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>品牌</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span>{{deviceItem.brandName}}</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>指定盘点人</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span>{{deviceItem.assignedStaffName}}</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>盘点人</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span>{{deviceItem.checkerName}}</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>是否已盘</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span>{{deviceItem.checked ? '已盘' : '未盘'}}</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>盘点结果</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span v-if="deviceItem.checked || voucher.state == 2">
                                <span v-if="deviceItem.checkedDelta == 0" class="font-green">正常</span>
                                <span v-else-if="deviceItem.checkedDelta > 0" class="font-red">盘盈</span>
                                <span class="font-red" v-else>盘亏</span>
                            </span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>实物状态</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span v-if="deviceItem.checked">
                                <span v-if="deviceItem.physicalState == 0" class="font-green">正常</span>
                                <span v-else-if="deviceItem.physicalState == -1">无实物</span>
                                <span class="font-red" v-else>损坏</span>
                            </span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>情况描述</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span>{{deviceItem.checkMemo}}</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>盘点时间</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span>{{deviceItem.checkTime}}</span>
                            </div>
                        </div>
                    </div>
                    <template v-if="handleItemMap != null && handleItemMap[deviceItem.id] != null">
                        <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: left;padding: 5px 0;background-color: rgb(239, 239, 239);" v-if="">
                            <span>处理结果</span>
                        </div>
                        <div style="overflow: hidden; padding: 5px 2px 10px;" v-for="handleItem in handleItemMap[deviceItem.id]">
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>处理方式</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <span class="font-red">{{handleItem.wayText}}</span>
                                </div>
                            </div>
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px" v-if="handleItem.doneVoucherNo != null">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>外部单据号</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <span>{{handleItem.doneVoucherNo}}</span>
                                </div>
                            </div>
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px" v-if="handleItem.wayValue == -2 || handleItem.wayValue == -3 || handleItem.wayValue == -4 || handleItem.wayValue == 2">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>出库机构</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <span v-if="handleItem.wayValue == -2 || handleItem.wayValue == -3 || handleItem.wayValue == -4">{{voucher.retailerComName}}</span>
                                    <span v-if="handleItem.wayValue == 2">{{handleItem.theOtherComName}}</span>
                                </div>
                            </div>
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px" v-if="handleItem.wayValue == -2 || handleItem.wayValue == -3 || handleItem.wayValue == -4 || handleItem.wayValue == 2">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>出库仓库</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <span v-if="handleItem.wayValue == -2 || handleItem.wayValue == -3 || handleItem.wayValue == -4">{{voucher.warehouseName}}</span>
                                    <span v-if="handleItem.wayValue == 2">{{handleItem.theOtherWarehouseName}}</span>
                                </div>
                            </div>
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>处理数量</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <span>{{handleItem.quantity}}</span>
                                </div>
                            </div>
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px" v-if="handleItem.wayValue == -2 || handleItem.wayValue == 2 || handleItemwayValue == 4">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>入库机构</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <span v-if="handleItem.wayValue == -2">{{handleItem.theOtherComName}}</span>
                                    <span v-if="handleItem.wayValue == 2 || handleItem.wayValue == 4">{{voucher.retailerComName}}</span>
                                </div>
                            </div>
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px" v-if="handleItem.wayValue == -2 || handleItem.wayValue == 2 || handleItem.wayValue == 4">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>入库仓库</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <span v-if="handleItem.wayValue == -2">{{handleItem.theOtherWarehouseName}}</span>
                                    <span v-if="handleItem.wayValue == 2 || handleItem.wayValue == 4">{{voucher.warehouseName}}</span>
                                </div>
                            </div>
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px" v-if="handleItem.wayValue == -2 || handleItem.wayValue == 2 || handleItem.wayValue == 3 || handleItem.wayValue == 4|| handleItem.wayValue == -4">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>单据类型</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <span v-if="handleItem.wayValue == -2 || handleItem.wayValue == 2">调拨单</span>
                                    <span v-if="handleItem.wayValue == -3">清理单</span>
                                    <span v-if="handleItem.wayValue == 4">入库单</span>
                                    <span v-if="handleItem.wayValue == -4">出库单</span>
                                </div>
                            </div>
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px" v-if="handleItem.clearCause != null">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>清理原因</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <span v-if="handleItem.wayValue == -3">{{devcClearCauseEnumMap[handleItem.clearCause]}}</span>
                                </div>
                            </div>
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px" v-if="handleItem.doneVoucherNo != null">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>单据号</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <span>{{handleItem.doneVoucherNo}}</span>
                                </div>
                            </div>
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px" v-if="voucher.done">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>执行完毕</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <span class="font-green" v-if="handleItem.done">已执行</span>
                                    <span v-else>未执行</span>
                                </div>
                            </div>
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px" v-if="voucher.done == false">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>能否生成单据</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <div v-if="handleItem.wayValue == 2">
                                        <span v-if="handleItem.theOtherComId != null && handleItem.theOtherWarehouseId != null">可以生成单据</span>
                                        <span v-else>无法生成单据</span>
                                    </div>
                                    <div v-if="handleItem.wayValue == -2">
                                        <div v-if="handleItem.theOtherComId != null">
                                            <span v-if="handleItem.theOtherComId != voucher.retailerComId">可以生成单据</span>
                                            <div v-if="handleItem.theOtherComId == voucher.retailerComId">
                                                <span v-if="handleItem.theOtherWarehouseId != null">可以生成单据</span>
                                                <span v-else>无法生成单据</span>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <span>无法生成单据</span>
                                        </div>
                                    </div>
                                    <div v-if="handleItem.wayValue == -3 || handleItem.wayValue == 4 || handleItem.wayValue == -4 || handleItem.wayValue == -6">
                                        <span>可以生成单据</span>
                                    </div>
                                </div>
                            </div>
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>执行时间</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <span>{{handleItem.doneTime}}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </template>
            <template v-if="durableItemList != null && durableItemList.length > 0">
                <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;" v-if="voucher.assetType != 2">批量式管理</div>
                <div style="border: 1px solid rgb(26, 26, 26); margin-top: 10px;" v-for="durableItem in durableItemList">
                    <div style="overflow: hidden; padding: 5px 2px 5px;">
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>系统编号</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">{{durableItem.tmpNo}}</div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>资产描述全称</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span>{{durableItem.title}}</span>
                                <span style="color: #2d8cf0;font-size: 12px;" v-if="durableItem.postAdded">追加</span>
                                <span style="color: #2d8cf0;font-size: 12px;" v-if="durableItem.outerFlag">助手</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>名称</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span>{{durableItem.name || ''}}</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>型号</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span>{{durableItem.model || ''}}</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>规格</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span>{{durableItem.fixedSpec || ''}}</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>分类</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span>{{durableItem.catName}}</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>分类分组</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span>{{getDevcGroupNameByCatId(durableItem.catId)}}</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>品牌</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span>{{durableItem.brandName}}</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>指定盘点人</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span>{{durableItem.assignedStaffName}}</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>盘点人</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span>{{durableItem.checkerName}}</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>是否已盘</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span>{{durableItem.checked ? '是' : '否'}}</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>盘点结果</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span v-if="durableItem.checked || voucher.state == 2">
                                <span v-if="durableItem.checkedDelta == 0" class="font-green">正常</span>
                                <span v-else-if="durableItem.checkedDelta > 0" class="font-red">盘盈</span>
                                <span class="font-red" v-else>盘亏</span>
                            </span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>盘点时间</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span>{{durableItem.checkTime}}</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>实盘数量</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span v-if="durableItem.checked || voucher.state == 2">{{durableItem.checkedQuantity}}</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>盘点差值</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span v-if="durableItem.checked || voucher.state == 2">{{durableItem.checkedDelta}}</span>
                            </div>
                        </div>
                        <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                            <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>情况描述</label>
                            </div>
                            <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                <span>{{durableItem.checkMemo}}</span>
                            </div>
                        </div>
                    </div>
                    <template v-if="handleItemMap != null && handleItemMap[durableItem.id] != null">
                        <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: left;padding: 5px 0;background-color: rgb(239, 239, 239);">
                            <span>处理结果</span>
                        </div>
                        <div style="overflow: hidden; padding: 5px 2px 10px;" v-for="handleItem in handleItemMap[durableItem.id]">
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>处理方式</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <span class="font-red">{{handleItem.wayText}}</span>
                                </div>
                            </div>
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px" v-if="handleItem.doneVoucherNo != null">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>外部单据号</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <span> {{handleItem.doneVoucherNo}}</span>
                                </div>
                            </div>
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px" v-if="handleItem.wayValue == -2 || handleItem.wayValue == -3 || handleItem.wayValue == -4 || handleItem.wayValue == 2">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>出库机构</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <span v-if="handleItem.wayValue == -2 || handleItem.wayValue == -3 || handleItem.wayValue == -4">{{voucher.retailerComName}}</span>
                                    <span v-if="handleItem.wayValue == 2">{{handleItem.theOtherComName}}</span>
                                </div>
                            </div>
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px" v-if="handleItem.wayValue == -2 || handleItem.wayValue == -3 || handleItem.wayValue == -4 || handleItem.wayValue == 2">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>出库仓库</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <span v-if="handleItem.wayValue == -2 || handleItem.wayValue == -3 || handleItem.wayValue == -4">{{voucher.warehouseName}}</span>
                                    <span v-if="handleItem.wayValue == 2">{{handleItem.theOtherWarehouseName}}</span>
                                </div>
                            </div>
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>处理数量</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <span>{{handleItem.quantity}}</span>
                                </div>
                            </div>
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px" v-if="handleItem.wayValue == -2 || handleItem.wayValue == 2 || handleItem.wayValue == 4">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>入库机构</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <span v-if="handleItem.wayValue == -2">{{handleItem.theOtherComName}}</span>
                                    <span v-if="handleItem.wayValue == 2 || handleItem.wayValue == 4">{{voucher.retailerComName}}</span>
                                </div>
                            </div>
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px" v-if="handleItem.wayValue == -2 || handleItem.wayValue == 2 || handleItem.wayValue == 4">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>入库仓库</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <span v-if="handleItem.wayValue == -2">{{handleItem.theOtherWarehouseName}}</span>
                                    <span v-if="handleItem.wayValue == 2 || handleItem.wayValue == 4">{{voucher.warehouseName}}</span>
                                </div>
                            </div>
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px" v-if="handleItem.wayValue == -2 || handleItem.wayValue == 2 || handleItem.wayValue == 3 || handleItem.wayValue == 4|| handleItem.wayValue == -4">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>单据类型</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <span v-if="handleItem.wayValue == -2 || handleItem.wayValue == 2">调拨单</span>
                                    <span v-if="handleItem.wayValue == -3">清理单</span>
                                    <span v-if="handleItem.wayValue == 4">入库单</span>
                                    <span v-if="handleItem.wayValue == -4">出库单</span>
                                </div>
                            </div>
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px" v-if="handleItem.clearCause != null">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>清理原因</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <span v-if="handleItem.wayValue == -3">{{devcClearCauseEnumMap[handleItem.clearCause]}}</span>
                                </div>
                            </div>
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px" v-if="handleItem.doneVoucherNo != null">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>单据号</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <span>{{handleItem.doneVoucherNo}}</span>
                                </div>
                            </div>
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px" v-if="voucher.done">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>执行完毕</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <span class="font-green" v-if="handleItem.done">已执行</span>
                                    <span v-else>未执行</span>
                                </div>
                            </div>
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px" v-if="voucher.done == false">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>能否生成单据</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <div v-if="handleItem.wayValue == 2">
                                        <span v-if="handleItem.theOtherComId != null && handleItem.theOtherWarehouseId != null">可以生成单据</span>
                                        <span v-else>无法生成单据</span>
                                    </div>
                                    <div v-if="handleItem.wayValue == -2">
                                        <div v-if="handleItem.theOtherComId != null">
                                            <span v-if="handleItem.theOtherComId != voucher.retailerComId">可以生成单据</span>
                                            <div v-if="handleItem.theOtherComId == voucher.retailerComId">
                                                <span v-if="handleItem.theOtherWarehouseId != null">可以生成单据</span>
                                                <span v-else>无法生成单据</span>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <span>无法生成单据</span>
                                        </div>
                                    </div>
                                    <div v-if="handleItem.wayValue == -3 || handleItem.wayValue == 4 || handleItem.wayValue == -4 || handleItem.wayValue == -6">
                                        <span>可以生成单据</span>
                                    </div>
                                </div>
                            </div>
                            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                                <div class="form-label" style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                    <label>执行时间</label>
                                </div>
                                <div style="padding-left: 76px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                                    <span>{{handleItem.doneTime}}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </template>
        </template>
    </div>

</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import { getDevcGroupNameByCatId } from '../index'
    import { showHtmlToPdfDlg } from '../ctrl/dialog'
    //
    import assetVchrApi from '../../api/assetVchr'

    export default {
        name: 'swb-shop-device-stcok-check-voucher-finish-for-pdf',
        desc: '盘点单导出',
        props: {
            voucherId: {
                type: Number,
                deafult: null,
            },
            assetType: {
                type: Number,
                deafult: null,
            },
        },
        data: function () {
            return {
                voucher: {},
                deviceItemList: [],
                durableItemList: [],
                handleItemMap: null,
                devcClearCauseEnumMap: getEnumMap('devcClearCause', 'value2text')
            }

        },
        created: function () {
            this.getShopDeviceStockCheckVoucher();
            this.getShopDeviceStockCheckVoucherItemDevice();
            this.getShopDeviceStockCheckVoucherItemDurable();
            this.getShopDeviceStockHandleItem();
        },
        methods: {
            getDevcGroupNameByCatId(catId){
                return getDevcGroupNameByCatId(catId);
            },
            getShopDeviceStockCheckVoucher: function () {
                let self = this;
                let theLoad = MsgBox.loading();
                let voucherId = self.voucherId;
                let postData = {
                    id: voucherId,
                    includeItems: false,
                    includeCount: true
                }
                assetVchrApi.getShopDeviceStockCheckVoucher(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let voucher = result.data;
                        self.voucher = voucher;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getShopDeviceStockCheckVoucherItemDevice: function () {
                let self = this;
                let postData = {
                    voucherId: self.voucherId,
                    durable: false
                }
                let theLoad = MsgBox.loading();
                assetVchrApi.getShopDeviceStockCheckItemByVoucherId(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let deviceItemList = result.data;
                        self.deviceItemList = deviceItemList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getShopDeviceStockCheckVoucherItemDurable: function () {
                let self = this;
                let postData = {
                    voucherId: self.voucherId,
                    durable: true
                }
                let theLoad = MsgBox.loading();
                assetVchrApi.getShopDeviceStockCheckItemByVoucherId(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let durableItemList = result.data;
                        self.durableItemList = durableItemList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getShopDeviceStockHandleItem: function () {
                let self = this;
                let postData = {
                    voucherId: self.voucherId,
                }
                let theLoad = MsgBox.loading();
                assetVchrApi.getShopDeviceStockHandleItemByVoucherId(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        self.handleItemMap = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getHtml: function () {
                return this.$el.outerHTML;

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceStockCheckVoucherFinishedForPdf.vue